<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';

  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;

  let nome = '';
  let email = '';
  let telefone = '';
  let cpf = '';
  let novaSenha = '';
  let confirmarSenha = '';

  $: if (tenant) {
    nome = tenant.nome || '';
    email = tenant.email || '';
    telefone = tenant.telefone || '';
    cpf = tenant.cpf || '';
  } else {
    nome = '';
    email = '';
    telefone = '';
    cpf = '';
  }

  onMount(() => {
    if (tenant) {
      nome = tenant.nome || '';
      email = tenant.email || '';
      telefone = tenant.telefone || '';
      cpf = tenant.cpf || '';
    }
  });

  async function salvarPerfil() {
    if (novaSenha !== '' && novaSenha !== confirmarSenha) {
      dispatch('recarregar', 'As senhas não coincidem!');
      return;
    }

    dispatch('loading', true);
    const url = Constantes.api_acesso.replace('acesso.php', 'atualizar_perfil.php');
    
    const res = await conexao.conecta(url, {
      body: { 
        id_tenant: tenant.id, 
        nome, 
        telefone, 
        cpf,
        nova_senha: novaSenha 
      }
    });

    dispatch('loading', false);
    
    if (res && res.sucesso) {
      novaSenha = '';
      confirmarSenha = '';
      dispatch('recarregar', res.mensagem);
    } else {
      dispatch('recarregar', res && res.mensagem ? res.mensagem : 'Erro ao guardar dados.');
    }
  }
</script>

<section class="card-panel fade-in">
  <h2>Meu perfil</h2>
  <p class="text-muted">Mantenha os seus dados profissionais e credenciais atualizados.</p>

  <div class="form-grid mt-4">
    <div class="grid-full">
      <label for="nome-perfil">Nome Completo</label>
      <input id="nome-perfil" type="text" class="input-app" bind:value={nome} />
    </div>
    
    <div class="grid-full">
      <label for="email-perfil">E-mail de acesso</label>
      <input id="email-perfil" type="email" class="input-app" value={email} readonly style="background: #f0f2f0; cursor: not-allowed; opacity: 0.8;" />
      <small class="text-muted">O e-mail de acesso não pode ser alterado depois do cadastro.</small>
    </div>

    <div class="grid-full">
      <label for="telefone-perfil">WhatsApp</label>
      <input id="telefone-perfil" type="text" class="input-app" bind:value={telefone} placeholder="(00) 00000-0000" />
    </div>

    <div class="grid-full">
      <label for="cpf-perfil">CPF</label>
      <input id="cpf-perfil" type="text" class="input-app" bind:value={cpf} placeholder="Apenas números" maxlength="14" />
    </div>

    <div class="grid-full mt-3 mb-2" style="border-top: 1px solid var(--border); padding-top: 20px;">
      <h3 style="font-size: 1rem; color: var(--primary);">Segurança da Conta</h3>
    </div>

    <div>
      <label for="nova-senha-perfil">Nova Senha</label>
      <input id="nova-senha-perfil" type="password" class="input-app" bind:value={novaSenha} placeholder="Deixe vazio para manter a atual" />
    </div>

    <div>
      <label for="confirmar-senha-perfil">Confirmar Nova Senha</label>
      <input id="confirmar-senha-perfil" type="password" class="input-app" bind:value={confirmarSenha} />
    </div>

    <div class="grid-full mt-3">
      <button class="btn-primary" on:click={salvarPerfil}>
        <i class="fas fa-check-circle me-2"></i> Atualizar Informações
      </button>
    </div>
  </div>
</section>

<style>
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .grid-full { grid-column: 1 / -1; }
  @media (max-width: 900px) { .form-grid { grid-template-columns: 1fr; } }
  @media (max-width: 640px) {
    .form-grid { gap: 16px; }
    .btn-primary { width: 100%; }
  }
</style>